module.exports = __webpack_public_path__ + "img/exit_hover.6f7b24a2.png";